class Accordion {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
		$(".js-acc-trigger").on("click", function () {
			$(this).toggleClass("is-active");
			$(this).next(".js-acc-content").slideToggle(200);
		});
	}
}
